import { Checkbox } from "@/components/ui/baseUi/checkbox"
import { cn } from "@/modules/lib/utils"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { LightProgramInfoEntity } from "@modules/programs/entities/lightProgramInfoEntity"
import { usePrograms } from "@modules/programs/hooks/usePrograms"
import { ProgramFilter } from "@modules/programs/types/programTypes"
import { ProgramReductionItem } from "@modules/promoCode/components/programReductionItem"
import { Text } from "@/components/ui/baseUi/text"

type ProgramListSelectionProps = {
  selectedProgramIds: string[]
  onSelectProgram: (id: string) => void
  onSelectAllPrograms: (allIds: string[]) => void
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
  error?: React.JSX.Element
  className?: string
}

export function ProgramListSelection({
  selectedProgramIds,
  onSelectProgram,
  onSelectAllPrograms,
  promoCodeType,
  promoCodeValue,
  promoCodeDuration,
  error,
  className,
}: ProgramListSelectionProps) {
  const { data: programs } = usePrograms({ programFilter: ProgramFilter.OWNED, onlyWithPrice: true, size: 80 })
  const lightProgramInfo = programs.content.map((program) => LightProgramInfoEntity.fromUserProgramItem(program))

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <div className="mb-2 flex flex-row items-center justify-between">
        <Text fontStyle="LL">{word("global.filters.selectAll")}</Text>
        <Checkbox
          checked={programs.content.length === selectedProgramIds.length}
          onCheckedChange={() => {
            onSelectAllPrograms(programs.content.map((program) => program.id))
          }}
          className="size-5"
        />
      </div>

      {lightProgramInfo.map((program) => (
        <div key={program.id} className="flex flex-row items-center justify-between">
          <ProgramReductionItem
            key={program.id}
            program={program}
            promoCodeType={promoCodeType}
            promoCodeValue={promoCodeValue}
            promoCodeDuration={promoCodeDuration}
          />
          <Checkbox
            className="size-5 shrink-0"
            value={program.id}
            checked={selectedProgramIds.some((id) => id === program.id)}
            onCheckedChange={() => {
              onSelectProgram(program.id)
            }}
            data-testid={program.id}
          />
        </div>
      ))}
      {error}
    </div>
  )
}
